import { Text } from '@bpba/ui-components';
import { FC } from 'react';
import { DEBIN_WARNING_TEXT1, DEBIN_WARNING_TEXT2, DEBIN_WARNING_TEXT3 } from '../constants/data';
import { GenericWarningContainer } from './GenericWarningContainer';

/**
 * Componente informativo que se muestra antes de confirmar
 * el envio del DEBIN a la cuenta bancaria del usuairo.
 */
export const DebinWarning: FC = () => {
  return (
    <GenericWarningContainer>
      <Text fontWeight={600}>{DEBIN_WARNING_TEXT1}</Text>
      <Text>{DEBIN_WARNING_TEXT2}</Text>
      <Text>{DEBIN_WARNING_TEXT3}</Text>
    </GenericWarningContainer>
  );
};
